import React from 'react';
import * as cls from './why-choose-voltaware.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { IMG_PATH } from '../../../constants';
import { ButtonBuyNow } from '../../../ui/components/button-buy-now';
import { CarouselHalf } from '../../../ui/components/carousel-half';

const items = [
  {
    ico: `${IMG_PATH}/home/why-choose-voltaware/track.svg`,
    title: 'Track Energy Use Appliance by Appliance',
    text: 'From your fridge to your washing machine, Voltaware detects individual appliances and shows exactly how much energy each one uses — and what it costs you.',
  },
  {
    ico: `${IMG_PATH}/home/why-choose-voltaware/sensor.svg`,
    title: 'One AI-Powered Sensor, Whole-Home Visibility',
    text: 'No smart plugs, no rewiring. One compact plug and play sensor wi-fi enabled sensorgives you a complete picture of your home’s electricity use — in real time.',
  },
  {
    ico: `${IMG_PATH}/home/why-choose-voltaware/monitor.svg`,
    title: 'Monitor in Real-Time and Save with the Voltaware App',
    text: (
      <>
        Use our mobile app (iOS & Android) to view live energy data,
        appliance-level usage, and tailored energy-saving tips.
        <br />
        <br />
        Access detailed daily, weekly, and monthly reports — including usage
        stats, cost breakdowns, and carbon footprint analysis.
      </>
    ),
  },
  {
    ico: `${IMG_PATH}/home/why-choose-voltaware/alerts.svg`,
    title: 'Get Smart Alerts, Cut Waste, and Improve Safety',
    text: 'Our home energy monitoring system notifies you when something’s off — from unusual spikes to forgotten appliances. Smart alerts help you avoid costly waste and identify early signs of electrical faults.',
  },
  {
    ico: `${IMG_PATH}/home/why-choose-voltaware/smarter.svg`,
    title: 'Smarter Every Day to Help You Save',
    text: 'The more you use Voltaware, the better it understands your home’s energy patterns. Our AI fine-tunes appliance detection and savings recommendations to maximise results.',
  },
];

export const WhyChooseVoltaware = () => {
  return (
    <section className={cls.section}>
      <div className={cls.texts}>
        <Typography tag="h2">Take Control of Your Energy Usage</Typography>

        <Typography style={{ maxWidth: 1050 }}>
          Voltaware’s AI-powered energy usage monitor — also known as an
          electricity usage tracking system — breaks down your electricity
          consumption by appliance, helping you finally understand how you use
          your energy at home, compare energy usage with peers, reduce energy
          waste, lower your energy bills, and monitor progress over time.
        </Typography>
      </div>

      <CarouselHalf className={cls.carousel}>
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <div className={cls.item__title}>
              <img src={item.ico} alt="" />
              <Typography as="p" tag="h3">
                {item.title}
              </Typography>
            </div>
            <Typography>{item.text}</Typography>
          </div>
        ))}
      </CarouselHalf>

      <div className={cls.button}>
        <ButtonBuyNow size="sm" />
      </div>
    </section>
  );
};
